export default __webpack_public_path__ + "static/media/img-guide-gt-popup-5-nl_dt.0a79cbb8.png";